import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@insight/toolkit-utils/lib/labels';
import Loading from '../Loading/Loading';
import Modal from '../Modal/Modal';
import { default as PDPBody } from './PDPBody';
import { PDPError } from './PDPError';

import { getPDP } from './usePDP';
import { connectToLocale } from '../Locale/Locale';

export const PDPModal = ({
  isIPSUser,
  isLoggedIn,
  displayListPrice,
  hasContractSection,
  showPDP,
  fetchProduct,
  onClose,
  showPrice,
  showSaving,
  showStock,
  showBackOrder,
}) => {
  if (!showPDP || !fetchProduct || typeof fetchProduct !== 'function')
    return null;

  const [pdp, loading, error] = getPDP(fetchProduct);

  const closeModal = () => {
    if (onClose) onClose();
  };

  const renderBody = () => {
    if (loading) return <Loading />
    if (error) return <PDPError closeModal={closeModal} />
    return (
      <PDPBody
        {...pdp}
        displayListPrice={displayListPrice}
        isLoggedIn={isLoggedIn}
        isIPSUser={isIPSUser}
        hasContractSection={hasContractSection || !!pdp?.price?.contractName}
        showPrice={showPrice}
        showSaving={showSaving || (isIPSUser && pdp?.price?.displayDiscount)}
        showStock={showStock}
        showBackOrder={showBackOrder}
      />
    );
  };

  return (
    <Modal
      isOpen
      onClose={closeModal}
      overlayclassname="c-modal-overlay"
      className="c-pdp-modal"
      size="medium"
    >
      <Modal.Header onClick={closeModal}>
        <h3 className="u-text-bold">{t('Product details')}</h3>
      </Modal.Header>
      <Modal.Body id="mini-pdp">{renderBody()}</Modal.Body>
    </Modal>
  );
};

PDPModal.propTypes = {
  displayListPrice: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isIPSUser: PropTypes.bool,
  hasContractSection: PropTypes.bool,
  /** conditional to display modal */
  showPDP: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Function to get product on load
   *  () => fetchProductInformation({
   *    locale: l(),
   *    materialId,
   *   })
   * }
   */
  fetchProduct: PropTypes.func.isRequired,
  /** callback function called when model is closed */
  onClose: PropTypes.func.isRequired,
  /** conditional to show list price and your price */
  showPrice: PropTypes.bool,
  /** conditional to show saving */
  showSaving: PropTypes.bool,
  /** conditional to show stock, used right now to hide stock for legacy users */
  showStock: PropTypes.bool,
  /* conditional to show backorder */
  showBackOrder: PropTypes.bool,
};

PDPModal.defaultProps = {
  displayListPrice: false,
  isLoggedIn: false,
  isIPSUser: false,
  hasContractSection: false,
  showPDP: false,
  showPrice: false,
  showSaving: false,
  showStock: true,
  showBackOrder: false,
};

export default connectToLocale(PDPModal);
